import { Nullable } from '@/types/utils'
import { IProfileSeed, IProfileFields } from '@/entities/Profile'
import ProfileValidator from '@/utils/validators/domain/Profile'

import {
  nameFormatError,
  nameLengthError,
  firstnameEmptyError,
  lastnameEmptyError,
  firstnameRubyEmptyError,
  lastnameRubyEmptyError,
  firstnameRubyFormatError,
  lastnameRubyFormatError,
  nicknameEmptyError,
  nicknameLengthError,
  telFormatError,
  birthEmptyError,
  birthFormatError,
  zipcodeEmptyError,
  zipcodeFormatError,
  prefectureEmptyError,
  prefectureFormatError,
  address1EmptyError,
  address2EmptyError,
  address1LengthError,
  address2LengthError,
  address3LengthError,
  // sexEmptyError,
  sexFormatError,
  readFlagEmptyError
} from '@/const/errorMessage'

export type Fields = Nullable<IProfileFields & IProfileSeed>

export type FieldErrors = { [key in keyof Fields]: string[] }

export default class ProfileFormValidator {
  static validate(fields: Partial<Fields>): FieldErrors {
    const errors: FieldErrors = {
      email: [],
      password: [],
      firstname: [],
      lastname: [],
      firstnameRuby: [],
      lastnameRuby: [],
      nickname: [],
      tel: [],
      birthYear: [],
      birthMonth: [],
      birthDay: [],
      zipcode: [],
      prefecture: [],
      address1: [],
      address2: [],
      address3: [],
      sex: [],
      readFlag: [],
      tlsc: []
    }

    const profileValidator = new ProfileValidator(fields)

    if (fields.firstname !== undefined) {
      if (!fields.firstname) {
        errors.firstname.push(firstnameEmptyError)
      } else {
        if (!profileValidator.isFirstnameFormatValid()) {
          errors.firstname.push(nameFormatError)
        }

        if (!profileValidator.isFirstnameLengthValid()) {
          errors.firstname.push(nameLengthError)
        }
      }
    }

    if (fields.lastname !== undefined) {
      if (!fields.lastname) {
        errors.lastname.push(lastnameEmptyError)
      } else {
        if (!profileValidator.isLastnameFormatValid()) {
          errors.lastname.push(nameFormatError)
        }

        if (!profileValidator.isLastnameLengthValid()) {
          errors.lastname.push(nameLengthError)
        }
      }
    }

    if (fields.firstnameRuby !== undefined) {
      if (!fields.firstnameRuby) {
        errors.firstnameRuby.push(firstnameRubyEmptyError)
      } else {
        if (!profileValidator.isFirstnameRubyFormatValid()) {
          errors.firstnameRuby.push(firstnameRubyFormatError)
        }

        if (!profileValidator.isFirstnameRubyLengthValid()) {
          errors.firstnameRuby.push(nameLengthError)
        }
      }
    }

    if (fields.lastnameRuby !== undefined) {
      if (!fields.lastnameRuby) {
        errors.lastnameRuby.push(lastnameRubyEmptyError)
      } else {
        if (!profileValidator.isLastnameRubyFormatValid()) {
          errors.lastnameRuby.push(lastnameRubyFormatError)
        }

        if (!profileValidator.isLastnameRubyLengthValid()) {
          errors.lastnameRuby.push(nameLengthError)
        }
      }
    }

    if (fields.nickname !== undefined) {
      if (!fields.nickname) {
        errors.nickname.push(nicknameEmptyError)
      } else if (!profileValidator.isNicknameLengthValid()) {
        errors.nickname.push(nicknameLengthError)
      }
    }

    if (fields.tel !== undefined) {
      if (!fields.tel) {
        errors.tel.push(telFormatError)
      } else if (!profileValidator.isTelValid()) {
        errors.tel.push(telFormatError)
      }
    }

    if (fields.birthYear !== undefined) {
      if (!fields.birthYear) {
        errors.birthYear.push(birthEmptyError)
      } else if (!profileValidator.isBirthYearValid()) {
        errors.birthYear.push(birthFormatError)
      }
    }

    if (fields.birthMonth !== undefined) {
      if (!fields.birthMonth) {
        errors.birthMonth.push(birthEmptyError)
      } else if (!profileValidator.isBirthMonthValid()) {
        errors.birthMonth.push(birthFormatError)
      }
    }

    if (fields.birthDay !== undefined) {
      if (!fields.birthDay) {
        errors.birthDay.push(birthEmptyError)
      } else if (!profileValidator.isBirthDayValid()) {
        errors.birthDay.push(birthFormatError)
      }
    }

    if (fields.zipcode !== undefined) {
      if (!fields.zipcode) {
        errors.zipcode.push(zipcodeEmptyError)
      } else if (!profileValidator.isZipcodeValid()) {
        errors.zipcode.push(zipcodeFormatError)
      }
    }

    if (fields.prefecture !== undefined) {
      if (!fields.prefecture) {
        errors.prefecture.push(prefectureEmptyError)
      } else if (!profileValidator.isPrefectureValid()) {
        errors.prefecture.push(prefectureFormatError)
      }
    }

    if (fields.address1 !== undefined) {
      if (!fields.address1) {
        errors.address1.push(address1EmptyError)
      } else if (!profileValidator.isAddress1LengthValid()) {
        errors.address1.push(address1LengthError)
      }
    }

    if (fields.address2 !== undefined) {
      if (!fields.address2) {
        errors.address2.push(address2EmptyError)
      } else if (!profileValidator.isAddress2LengthValid()) {
        errors.address2.push(address2LengthError)
      }
    }

    if (fields.address3 !== undefined) {
      if (fields.address3) {
        if (!profileValidator.isAddress3LengthValid()) {
          errors.address3.push(address3LengthError)
        }
      }
    }

    if (fields.sex !== undefined) {
      if (fields.sex) {
        if (!profileValidator.isSexValid()) {
          errors.sex.push(sexFormatError)
        }
      }
    }

    if (fields.readFlag !== undefined) {
      if (!profileValidator.isReadFlagValid()) {
        errors.readFlag.push(readFlagEmptyError)
      }
    }

    return errors
  }
}
